import { OfferFilter } from 'cpool-schemas';
import { z } from 'zod';

export const offerManagementSearchSchema = z.object({
    offerFilter: OfferFilter.optional().nullable(),
});

export type OfferManagementSearch = z.infer<typeof offerManagementSearchSchema>;
